'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _elementPositionSelector = require('./elementPositionSelector');

var _cssUtil = require('../utils/cssUtil');

require('./ElementPositioner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps() {
    return (0, _reselect.createSelector)((0, _elementPositionSelector.makeGetElementPixelPosition)(), function (elementPosition) {
        return { elementPosition: elementPosition };
    });
};

// Styles


// Selectors
// Lib


var ElementPositioner = function ElementPositioner(_ref) {
    var children = _ref.children,
        elementPosition = _ref.elementPosition;
    return _react2.default.createElement(
        'div',
        { className: 'ElementPositioner', style: (0, _cssUtil.getTranslationStyles)(elementPosition) },
        children
    );
};

ElementPositioner.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    elementId: _propTypes2.default.string.isRequired,
    elementPosition: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ElementPositioner);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/ElementPositioner.js
// module id = 1947
// module chunks = 0